import React, { useContext } from 'react';
import { Footer, TripleAction, RouterContext } from '../../gs-component-right-rail';
import { FormikTouched } from 'formik';
import { Household, FormProps, FocusOn } from '../interfaces';
import { track } from '../helpers/analytics';
import Households from './Households';
import LegalSms from '../Legal/LegalSms';

interface RightRailBulkEditProps {
  dirty: boolean;
  submitForm: () => void;
  isValid: boolean;
  householdsList?: Household[];
  focusOn?: FocusOn;
  onClose: () => void;
  touched: FormikTouched<FormProps>;
  analyticsObject?: object;
  setShouldClose: (arg0: boolean) => void;
}

const RightRailBulkEdit: React.FC<RightRailBulkEditProps> = ({
  householdsList,
  onClose,
  submitForm,
  isValid,
  dirty,
  focusOn,
  setShouldClose,
  touched = {},
  analyticsObject = {},
}) => {
  const { push } = useContext(RouterContext);

  const closeRail = (): void => {
    if (dirty) {
      push('cancel');
    } else {
      onClose();
    }
  };

  return (
    <>
      <Households focusOn={focusOn!} householdsList={householdsList!} />
      {focusOn && focusOn === FocusOn.phone && <LegalSms />}
      <Footer>
        <TripleAction
          primaryText="Save"
          secondaryText="Cancel"
          primaryOnClick={(): void => {
            setShouldClose(true);
            submitForm();
            track('Guest Modal Interaction', analyticsObject);
          }}
          secondaryOnClick={closeRail}
          primaryDisabled={!isValid}
        />
      </Footer>
    </>
  );
};

export default RightRailBulkEdit;
